import { defineMessages } from 'react-intl';

export default defineMessages({
  orderDashboardLabel: {
    id: 'navigation.orderDashboard',
    description: 'order dashboard label',
    defaultMessage: 'Order Dashboard',
  },
});
